import { render } from "./invite-friends.vue?vue&type=template&id=157c9f92&scoped=true"
import script from "./invite-friends.vue?vue&type=script&lang=js"
export * from "./invite-friends.vue?vue&type=script&lang=js"

import "./invite-friends.vue?vue&type=style&index=0&id=157c9f92&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157c9f92"]])

export default __exports__